import { TradingStore } from "./Trading";
import AppealStore from "./appeal";
import { ChatAppealStore } from "./chat_appeals";
import { ChatOrderStore } from "./chat_orders";
import CommonStore from "./common";
import MarketContractStore from "./contract";
import MyWalletStore from "./my-wallet";
import { OrderStore } from "./orders";

import { UserStore } from "./user";

export default class Store {
  static type = {
    userStore: "userStore",
    tradingStore: "tradingStore",
    commonStore: "commonStore",
    chatOrderStore: "chatOrderStore",
    orderStore: "orderStore",
    contractStore: "contractStore",
    myWalletStore: "myWalletStore",
    appealStore: "appealStore",
    chatAppealStore: "chatAppealStore",
  };
  private userStore: UserStore;
  private tradingStore: TradingStore;
  private commonStore: CommonStore;
  private chatOrderStore: ChatOrderStore;
  private orderStore: OrderStore;
  private contractStore: MarketContractStore;
  private myWalletStore: MyWalletStore;
  private appealStore: AppealStore;
  private chatAppealStore: ChatAppealStore;
  constructor() {
    this.userStore = new UserStore();
    this.contractStore = new MarketContractStore();
    this.tradingStore = new TradingStore(this.contractStore);
    this.commonStore = new CommonStore();
    this.chatOrderStore = new ChatOrderStore();
    this.orderStore = new OrderStore();

    this.myWalletStore = new MyWalletStore();
    this.appealStore = new AppealStore();
    this.chatAppealStore = new ChatAppealStore();
  }
  public getStores = () => ({
    [Store.type.userStore]: this.userStore,
    [Store.type.tradingStore]: this.tradingStore,
    [Store.type.commonStore]: this.commonStore,
    [Store.type.chatOrderStore]: this.chatOrderStore,
    [Store.type.orderStore]: this.orderStore,
    [Store.type.contractStore]: this.contractStore,
    [Store.type.myWalletStore]: this.myWalletStore,
    [Store.type.appealStore]: this.appealStore,
    [Store.type.chatAppealStore]: this.chatAppealStore,
  });
}
